export function getTimeWithTimeZone(dateTime: Date, timeZone: string): Date {
	return new Date(dateTime.toLocaleString('en-US', {timeZone}));
}